import { render, staticRenderFns } from "./vendor_rating_review_report.vue?vue&type=template&id=516e2195&"
import script from "./vendor_rating_review_report.vue?vue&type=script&lang=js&"
export * from "./vendor_rating_review_report.vue?vue&type=script&lang=js&"
import style0 from "./vendor_rating_review_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports